import * as types from './mutation-types'

export default {
  setPublishing ({ commit }, payload) {
    commit(types.SET_PUBLISHING, payload)
  },
  setSavingDraft ({ commit }, payload) {
    commit(types.SET_SAVING_DRAFT, payload)
  },
  setIsPostSidebarOpen ({ commit }, payload) {
    commit(types.SET_POST_SIDEBAR_OPEN, payload)
  },
  setPostData ({ commit }, payload) {
    commit(types.SET_POST_DATA, payload)
  }
}
